/**
 * Helper to download an Excel template from its Base64 representation.
 * @param base64Content The base64-encoded string of the Excel file.
 * @param filename The name of the file to download (including extension, e.g., 'template.xlsx').
 */
export const downloadBase64Excel = (base64Content: string, filename: string) => {
  try {
    const cleanBase64 = base64Content.trim().replace(/\s/g, '');
    const byteCharacters = atob(cleanBase64);
    const byteNumbers = new Array(byteCharacters.length);
    for (let i = 0; i < byteCharacters.length; i++) {
      byteNumbers[i] = byteCharacters.charCodeAt(i);
    }
    const byteArray = new Uint8Array(byteNumbers);
    const blob = new Blob([byteArray], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
    const url = URL.createObjectURL(blob);

    const link = document.createElement('a');
    link.href = url;
    link.download = filename;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    URL.revokeObjectURL(url);
  } catch (error) {
    console.error(`Failed to download template ${filename}:`, error);
  }
};
